import { createApp } from "vue";
import App from "/App.vue"; // Import the root App.vue component

import setupInterceptors from "./services/setupInterceptors";
import { loadFonts } from "./plugins/webfontloader";
import "./assets/scss/styles.scss";
import "./helpers.js";
import "vue3-toastify/dist/index.css";

import { createCustomElement } from "./util/createCustomElement";
import VragenlijstComponent from "./components/vragenlijst-component.vue";

// Load fonts and setup interceptors
loadFonts();
setupInterceptors();

// Create and register custom elements
const VragenlijstElement = createCustomElement(VragenlijstComponent);
if (!customElements.get("vragenlijst-component")) {
  customElements.define("vragenlijst-component", VragenlijstElement);
}

// Create the Vue application
const app = createApp(App);

// Mount the app
app.mount("#app");
